"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamsService = void 0;
const api_1 = require("../api");
const utils_1 = require("../utils");
class StreamsService {
    constructor(fetch) {
        this.apiVersion = api_1.apiVersion;
        this.fetch = fetch;
    }
    listStreams(params = {}) {
        return this.fetch(`/${this.apiVersion}/streams?response_schema_v=v2&${(0, utils_1.toSearchParams)(params)}`);
    }
    getStream(params) {
        return this.fetch(`/${this.apiVersion}/streams/${params.id}?response_schema_v=v2&${(0, utils_1.toSearchParams)(params)}`);
    }
    createStream({ stream, allowEquivalent = false, allowEvolution = false, }) {
        const params = (0, utils_1.toSearchParams)({
            response_schema_v: "v2",
            allow_equivalent: allowEquivalent,
            allow_evolution: allowEvolution,
        });
        return this.fetch(`/${this.apiVersion}/streams?${params}`, {
            method: "POST",
            body: stream,
        });
    }
    deleteStream(id) {
        return this.fetch(`/${this.apiVersion}/streams/${id}?response_schema_v=v2&`, {
            method: "DELETE",
        });
    }
    updateStream(params) {
        const { id, body } = params;
        return this.fetch(`/${this.apiVersion}/streams/${id}?response_schema_v=v2&`, {
            method: "PATCH",
            body,
        });
    }
    /** @deprecated Use the StreamsDataService instead */
    clearStream(id) {
        return this.fetch(`/${this.apiVersion}/streams/${id}/clear?response_schema_v=v2&`, {
            method: "POST",
        });
    }
    getDependencies(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.fetch(`/${this.apiVersion}/streams/${params.id}/dependencies?response_schema_v=v2&`);
            [...Object.values(result.inputs), ...Object.values(result.outputs)].forEach((v) => (v.resourceType = v.resourceType.toUpperCase()));
            return result;
        });
    }
    getPreview(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.fetch(`/${this.apiVersion}/streams/${params.id}/preview`);
        });
    }
    getPreviewToken(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.fetch(`/${this.apiVersion}/streams/${params.id}/preview/token`, {
                method: "POST",
            });
        });
    }
    getClearToken(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.fetch(`/${this.apiVersion}/streams/${params.id}/clear/token`, {
                method: "POST",
            });
        });
    }
}
exports.StreamsService = StreamsService;
exports.default = StreamsService;
